import Vue from 'vue'
import CreateAPI from 'vue-create-api'
import PcTabMessageDialog from 'components/PcTabMessageDialog'
import Notify from 'components/Notify'

Vue.use(CreateAPI)

Vue.createAPI(PcTabMessageDialog, true)
Vue.createAPI(Notify, true)

export const MessageDialog = PcTabMessageDialog